import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';

import { BasePage, TabletScreen, MobileScreen, StaticContext, Helmet } from '@sm/webassets';
import { Grid, Row, Col } from '@sm/wds-react';
import { MetricsTracker, USER_EVENTS } from '@sm/metrics';
import { getClientEnvironmentDetails } from '@sm/utils';

import NavBar from '../components/NavBar';
import UCSModule from '../../components/UCSModule';

import getCanonicalUrlOrNoIndex from '~app/helpers/getCanonicalUrlOrNoIndex';

import './app-directory-base-page.scss';
import ModernHeader from '../components/ModernHeader';

const AppDirectoryBasePage = ({ id, header, navbar, pageMetricsAttributes, children }) => {
  const {
    environment: { subdomain, domain, tld },
    userAgent,
    user,
    url,
  } = useContext(StaticContext);
  const { isDesktop } = getClientEnvironmentDetails(userAgent);

  const { noIndex, canonicalUrl } = getCanonicalUrlOrNoIndex(subdomain, domain, tld, url);

  useEffect(() => {
    MetricsTracker.track({
      name: USER_EVENTS.PAGE_VIEW,
      data: {
        amplitudeEvent: 'page viewed',
        isMarketing: true,
        pageName: id.toLowerCase(),
        urlPath: window.location.pathname,
        referrer: document.referrer,
        networkName: 'SurveyMonkey',
      },
    });
  }, [id]);

  return (
    <BasePage pageId={id} includeHeader={false} pageMetricsAttributes={pageMetricsAttributes} legacyWeb="papi">
      <Helmet>
        <If condition={!noIndex}>
          <link rel="canonical" href={canonicalUrl} />
        </If>
        <If condition={noIndex}>
          <meta name="robots" content="noindex, nofollow" />
        </If>
      </Helmet>
      {header}
      <If condition={user.isAuthenticated}>
        <UCSModule moduleName="top_bar" customLoader={<div />} />
      </If>
      <Grid fluid className="sm-app-directory-base-page">
        <div className="wds-p-l-5 wds-p-r-5">
          <MobileScreen defaultMatches={!isDesktop}>
            <Row>
              <Col>{navbar}</Col>
            </Row>
          </MobileScreen>
          <Row>
            <TabletScreen defaultMatches={isDesktop}>
              <Col lg={3}>{navbar}</Col>
            </TabletScreen>
            <Col>{children}</Col>
          </Row>
        </div>
      </Grid>
    </BasePage>
  );
};

AppDirectoryBasePage.propTypes = {
  id: PropTypes.string.isRequired,
  header: PropTypes.node,
  navbar: PropTypes.node,
  children: PropTypes.node.isRequired,
  pageMetricsAttributes: PropTypes.shape({}),
};

AppDirectoryBasePage.defaultProps = {
  header: <ModernHeader />,
  navbar: <NavBar />,
  pageMetricsAttributes: null,
};

export default AppDirectoryBasePage;
